import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { principles } from "@/mocks/home";

export default function Principles() {
  const root = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!root.current) return;
    const ctx = gsap.context(() => {
      gsap.from(".principle-card", {
        y: 50,
        opacity: 0,
        duration: 1,
        stagger: 0.1,
        ease: "power3.out",
        scrollTrigger: { trigger: root.current, start: "top 75%" },
      });
    }, root);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={root} className="bg-bone py-16 md:py-20 px-6 md:px-10">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <p className="text-[11px] font-mono uppercase tracking-[0.22em] text-ink/50 mb-4">
            ✦ Four promises
          </p>
          <h3 className="font-display text-4xl md:text-6xl text-ink tracking-tightest font-light leading-[0.95]">
            Principles, <span className="font-display text-rust">not policies.</span>
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {principles.map((p) => (
            <div
              key={p.title}
              className="principle-card group relative p-8 bg-sand/40 rounded-2xl hover:bg-sand transition-colors cursor-pointer border border-ink/5"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-forest text-bone mb-6 group-hover:bg-rust transition-colors">
                <i className={`${p.icon} text-xl`}></i>
              </div>
              <h4 className="font-display text-2xl text-ink tracking-tightest font-medium mb-3">
                {p.title}
              </h4>
              <p className="text-sm text-ink/70 leading-relaxed">{p.body}</p>
              <i className="ri-arrow-right-up-line absolute top-7 right-7 text-ink/30 group-hover:text-ink transition-colors"></i>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}